import { createStore } from 'effector';
import { GiftRepurschase } from './entities';

export const $giftRepurchases = createStore<GiftRepurschase[]>([]);
